import { gql } from '@apollo/client';

export const LIBRARY_URL_SUB_DIRECTORY_QUERY = gql`
  query LibraryUrlSubdirectory($locale: String!, $preview: Boolean!) {
    libraryUrlSubdirectoryCollection(locale: $locale, preview: $preview) {
      items {
        sys {
          locale
        }
        urlSubdirectory
        contentTypes
      }
    }
  }
`;
